<template>
  <div class="rank-box">
    <div class="rank-item">
      <div v-for="(item, index) in header" :style="custumStyle" :key="index"
        :class="(hasNo && (item == '编号' || item == '序号')) ? 'no' : ''" style="color:white">{{ item }}</div>
    </div>
    <!-- v-infinite-scroll="load" -->
    <div class="scroll-box" v-if="value.length > 0" infinite-scroll-distance="5">
      <div class="rank-item rank-row" v-for="(item, index) in value" :key="index" @click="handleRowClick(item, index)">
        <div v-for="(obj, objIndex) in item.values" :style="custumStyle" :key="objIndex"
          :class="[errorTxt.includes(obj) ? 'error' : '', (hasNo && objIndex == 0) ? 'no' : '']">{{ obj }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    errorTxt: {
      type: Array,
      default: () => {
        return ["异常"]
      }
    },
    firstWidth: {
      type: Number,
      default: () => {
        return 40
      }
    },
    header: {
      type: Array,
      default: () => [
        "武川县",
        "企业类型",
        "主体属性",
        "所属行业",
        "主体状态",
        "注册日期",
      ],
    },
    custumStyle: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    hasNo: function () {
      return this.header.includes("编号") || this.header.includes("序号")
    }
  },
  data() {
    return {};
  },
  methods: {
    load() {
      this.$emit("load")
    },
    handleRowClick(item, index) {
      this.$emit("row-click", item, index)
    }
  }
};
</script>
<style lang="scss" scoped>
.rank-box {
  display: flex;
  flex-direction: column;
  width: 100%;

  .scroll-box {
    max-height: 350px;
    overflow: auto;
  }

  .rank-item {
    display: flex;
    align-items: center;
    padding: 5px 20px;
    margin-bottom: 5px;
    background: linear-gradient(90deg,
        rgba(0, 20, 28, 0.3) 0%,
        rgba(1, 32, 45, 0.3) 50%,
        rgba(0, 20, 28, 0.3) 100%);
    box-sizing: border-box;

    div {
      flex: 1;
      min-width: 90px;
      height: 100%;

      text-align: center;
      color: rgba(165, 223, 247, 1);
      font-size: 16px;
    }

  }

  .rank-row {
    cursor: pointer;
  }

  .error {
    color: rgba(254, 92, 92, 1) !important;
  }
}

.no {
  max-width: 40px !important;
}

::-webkit-scrollbar {
  width: 4px;
  height: 150px !important;
  background: linear-gradient(180deg, #96E3FF 0%, #339BFA 42%, #2182F9 63%, #3F94F1 81%, #76DEFF 100%) !important;
}
</style>
